<!-- Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved. -->
<div class="hce-loading-overlay" role="status" aria-live="polite">
  <div class="hce-loading-body">
    <mat-progress-spinner mode="indeterminate" diameter="56"></mat-progress-spinner>

    <!-- Title (primary line) -->
    <div class="hce-loading-title" *ngIf="title.trim()">{{ title }}</div>

    <!-- Sub tasks (secondary line) -->
    <div class="hce-loading-tasks" *ngIf="tasks.length">
      <div class="task-row" *ngFor="let t of tasks">
        <mat-progress-spinner
          *ngIf="t.status !== 'done'"
          class="task-icon spin"
          mode="indeterminate"
          diameter="16"
        ></mat-progress-spinner>
        <mat-icon
          *ngIf="t.status === 'done'"
          class="task-icon done material-symbols-outlined"
          aria-hidden="true"
        >
          check_circle
        </mat-icon>
        <span class="task-label">{{ t.label }}</span>
      </div>
    </div>
  </div>
</div>